/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import * as icons from '@salesforce/retail-react-app/app/components/icons';
import Link from '@salesforce/retail-react-app/app/components/link';

import * as components from '@amblique/base/app/components/shared/ui/components';

const RAW_COMPONENTS = {
  'a': [Link, {parse: true}],
  'a[button]': [components.Button, {as: Link, parse: true}],
  'div': components.Box,
  'hr': components.Divider,
  'img': components.Image,
  'input[checkbox]': components.Checkbox,
  'input[radio]': components.Radio,
  'span': [components.Text, {as: 'span'}],
  'p': components.Text,
  'li': components.ListItem,
  'ul': components.UnorderedList,
  'ol': components.OrderedList,
};

for (const [name, component] of Object.entries(icons)) {
  RAW_COMPONENTS[name.toLowerCase()] = component;
}

for (const [name, component] of Object.entries(components)) {
  RAW_COMPONENTS[name.toLowerCase()] = component;
}

export {RAW_COMPONENTS};
